import React from 'react';
import './ToggleSwitch.css';

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    small?: boolean;
}

/** iPhone-style toggle. Render it inside a label, which names it and makes the text clickable too. */
const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, small }) => (
    <input
        type="checkbox"
        role="switch"
        className={`toggle-switch${small ? ' toggle-switch--small' : ''}`}
        checked={checked}
        onChange={e => onChange(e.target.checked)}
    />
);

export default ToggleSwitch;
